(function() {
    angular
        .module("dashboard")
        .controller(
            "OrderUpDisconnectedModalController",
            [
                "$scope",
                "$uibModalInstance",
                "callback",
                OrderUpDisconnectedModalController
            ]
        );

    function OrderUpDisconnectedModalController(
        $scope,
        $uibModalInstance,
        callback
    ) {
        $scope.reload = function () {
            callback();
            $uibModalInstance.close();
        }
    }
})();
